import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dataManagerEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-insight-global-configuration-data-manager-main" */ './data-manager-main.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
